import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'

import ReceiptForm from '@/modules/receipt/form/receipt-form'
import ReceiptAnalyseResult from '@/modules/receipt/analyse-result/receipt-analyse-result'

const ReceiptEditFormWrapper = (props) => {
  const { data = {}, onChange, isDocumentInvoiceReviewMode, documentReviewFormOnly } = props
  const { filesToAssign = [] } = useSelector(state => state.receipt.edit)
  const {
    id,
    state,
    receipts = [],
    filledData = [],
    ocrDataChanged,
    metaData,
  } = data

  useEffect(() => {
    if (filesToAssign.length) {
      const [file] = filesToAssign

      onChange({
        receiptNumber: (props.data.receiptNumber || file.receiptNumber) ?? '-',
        date: (props.data.date || file.recordDate) ?? null,
        deliveryDate: (props.data.deliveryDate || file.recordDate) ?? null,
      })
    }
  }, [filesToAssign.length])

  return (
    <>
      {/* FLAG:useDocuAi — the legacy analysis card („Beleg zur Prüfung vorhanden", „KI-Beleganalyse
          erfolgreich", „n Werte gefüllt") belongs to the OLD path, where an uploaded receipt filled
          a few fields of the expense form. The review component states all of that in its own header,
          so inside the review the card says the same thing twice — and it used to render there
          unconditionally, because its only silence is "no receipts, no filled values, no identified
          values at all".

          That is exactly what breaks at the moment of saving: the save attaches the receipt to the
          record, the card suddenly HAS content, and it renders it while the host is still navigating
          away. Measured 2026-09-18 over a save in /documents/review (plan
          omxweb-draft-receipt-instead-of-review-row T22): at 874 ms the route was already /documents
          while the review surface still stood, with the card's own texts on screen; at 1044 ms the
          view was gone. Reported as „beim Speichern in Prüfen erscheint für einen Moment die alte
          Prüfkomponente ohne Gate, ca. halbe Sekunde".

          Only the review surface is affected. The plain expense/revenue form — and every flag-OFF
          tenant, which never has a review surface — renders the card exactly as before.

          `documentReviewFormOnly` is the SECOND half of the same rule, added 2026-09-18 after Ralf
          saw the card flash on the revenue side („beim Speichern sonstige Einnahmen erscheint auch
          die alte Prüfkomponente kurz"). EmbeddedInvoiceReview has two form branches, and its
          MANUAL one (isManualEntry, the receipt without an analysis result) passes only
          `documentReviewFormOnly`, not `documentReviewFileId` — so `isDocumentInvoiceReviewMode`
          was false there and the card came back. `documentReviewFormOnly` means „a review host
          draws the preview column, we are the form inside it", which is exactly the situation the
          card must stay out of, and it is set by review hosts ONLY (embedded review ×2, the
          documents review drawer). Both plain forms leave it false, and flag-OFF has no review
          host at all. */}
      {!isDocumentInvoiceReviewMode && !documentReviewFormOnly && (
        <ReceiptAnalyseResult
          id={id}
          state={state}
          receipts={[...receipts, ...filesToAssign]}
          filledData={filledData}
          ocrDataChanged={ocrDataChanged}
          identifiedValues={metaData?.analysis?.indentifiedValues} />
      )}
      <ReceiptForm {...props} />
    </>
  )
}

export default ReceiptEditFormWrapper
